





















import { Component, Vue, Prop, Provide } from 'vue-property-decorator'
import Warning from './Warning.vue'

@Component({ components: { Warning } })
export default class GProgress extends Vue {
  @Prop() num!: number | string
  public signs = [
    { percent: '12.5%', text: '5' },
    { percent: '25%', text: '10' },
    { percent: '100%', text: '40' }
  ]
  public get percentage() {
    return Number(this.num) >= 40 ? '100%' : (Number(this.num) / 40) * 100 + '%'
  }
  public get count() {
    return this.num ? this.num + '' : '0'
  }
}
